import useSearch from './useSearch';
export default useSearch;
//# sourceMappingURL=index.js.map